import { render, staticRenderFns } from "./TextUnixTimestamp.vue?vue&type=template&id=49ef639c&"
import script from "./TextUnixTimestamp.vue?vue&type=script&lang=js&"
export * from "./TextUnixTimestamp.vue?vue&type=script&lang=js&"
import style0 from "./TextUnixTimestamp.vue?vue&type=style&index=0&id=49ef639c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports